module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    报名活动添加/更改\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "150px",
      "label-position": "right"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name",
      "rules": [{
        required: true,
        message: '请输入活动名称',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "名称"
    },
    on: {
      "change": _vm.fieldItemChange
    },
    model: {
      value: (_vm.form.activity_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.activity_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动有效时间",
      "prop": "activity_time"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "format": "yyyy/MM/dd HH:mm:ss",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择报名问卷模板",
      "prop": "temp_id",
      "rules": [{
        required: true,
        message: '请选择报名问卷模板',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.selectTempId
    },
    model: {
      value: (_vm.form.temp_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "temp_id", $$v)
      },
      expression: "form.temp_id"
    }
  }, _vm._l((_vm.temp_options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提交报名次数",
      "prop": "join_limit",
      "rules": [{
        required: true,
        message: '请输入报名次数',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "placeholder": "次数"
    },
    on: {
      "change": _vm.fieldItemChange
    },
    model: {
      value: (_vm.form.join_limit),
      callback: function($$v) {
        _vm.$set(_vm.form, "join_limit", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.join_limit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启短信通知",
      "prop": "is_sms_notice"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_sms_notice),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_sms_notice", $$v)
      },
      expression: "form.is_sms_notice"
    }
  }), _vm._v(" "), (_vm.form.is_sms_notice) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                您参与的\"活动名称\"活动，已经\"审核结果\"(允许参与 或 已拒绝)\n              ")])]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否开启小程序通知",
      "prop": "is_wxapp_notice"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.form.is_wxapp_notice),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_wxapp_notice", $$v)
      },
      expression: "form.is_wxapp_notice"
    }
  }), _vm._v(" "), (_vm.form.is_wxapp_notice) ? _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("报名结果通知")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                活动名称：" + _vm._s(_vm.form.activity_name) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_vm._v("\n                报名结果：报名已通过(或 报名被拒绝)\n              ")])]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAction
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2c93f5b1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c93f5b1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/registrationactivityadd.vue
// module id = 2574
// module chunks = 0